var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import { FormHelperText, styled } from '@mui/material';
import React, { forwardRef } from 'react';
import { LabelPlacement } from '../Form/FormInputProps';
import InputLabel from '../InputLabel';
import SFormControl from '../SFormControl';
import { OutlinedInput } from '@mui/material';
var InputWrapper = styled('div')({
    flexGrow: 1,
    margin: 0,
});
var SOutlinedInput = styled(OutlinedInput)({
    width: '100%',
});
var TextFormInput = forwardRef(function (_a, ref) {
    var _b = _a.boldLabel, boldLabel = _b === void 0 ? false : _b, _c = _a.Component, Component = _c === void 0 ? SOutlinedInput : _c, _d = _a.disabled, disabled = _d === void 0 ? false : _d, errorMessage = _a.errorMessage, hintMessage = _a.hintMessage, _e = _a.insets, insets = _e === void 0 ? false : _e, label = _a.label, _f = _a.labelPlacement, labelPlacement = _f === void 0 ? LabelPlacement.TOP : _f, optional = _a.optional, _g = _a.required, required = _g === void 0 ? false : _g, value = _a.value, children = _a.children, props = __rest(_a, ["boldLabel", "Component", "disabled", "errorMessage", "hintMessage", "insets", "label", "labelPlacement", "optional", "required", "value", "children"]);
    var error = !!errorMessage;
    var helperText = errorMessage || hintMessage;
    return (React.createElement(SFormControl, __assign({}, { error: error, required: required, insets: insets, labelPlacement: labelPlacement }),
        label && (React.createElement(InputLabel, __assign({}, { boldLabel: boldLabel, optional: optional, labelPlacement: labelPlacement, required: required }), label)),
        React.createElement(InputWrapper, null,
            children || (React.createElement(Component, __assign({}, { disabled: disabled, error: error, value: value }, props, { inputProps: __assign({ 'aria-label': label }, (props.inputProps || [])), inputRef: ref }))),
            helperText && React.createElement(FormHelperText, null, helperText))));
});
TextFormInput.displayName = 'TextFormInput';
export default TextFormInput;
